import React, { FC, useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import LabelGroupModule from './LabelGroupModule'
import LoadingSquare from '../common/LoadingSquare'

interface LabelGroup {
  id: number // ラベルグループID
  name: string // ラベルグループ名
  code: string | null
  color: string
  disabled: boolean // 非活性フラグ
  scheduled_start_date: string | null
  scheduled_end_date: string | null
  report_view: boolean
  permission: {
    viewable: {
      teams: {
        id: number
        name: string
      }[]
      members: {
        id: number
        name: string
      }[]
    }
    usable: {
      teams: {
        id: number
        name: string
      }[]
      members: {
        id: number
        name: string
      }[]
    }
  }
  labels: { // ラベル
    id: number // ラベルID
    label_master_id: number
    name: string // ラベル名
    code: string | null
    color: string // 色
    auto_labelings: { // オートラベリング
      id: number | null
      services: string[]
      keyword: {
        operator: string | null
        words: string[]
      }
      file_paths: string[]
      url: {
        pattern: string | null
        words: string[]
      }
      teams: {
        id: number
        name: string
      }[]
      members: {
        id: number
        name: string
      }[]
    }[]
    disabled: boolean // 非活性フラグ
  }[]
  auto_budgets: {
    start_date: string
    end_date: string | null
    budget: number
  }[]
  auto_other_costs: {
    start_date: string
    end_date: string | null
    name: string
    cost: number
  }[]
  auto_scheduled_times: {
    start_date: string
    end_date: string | null
    time: number
  }[]
  created_at: string
  created_by: string | null
}

interface LabelGroupCategory {
  id: number | null
  category_name: string
  color: string
  parent_id: number | null
  label_groups: LabelGroup[]
  page_count: number
}

interface Team {
  id: number
  name: string
  members: {
    id: number
    name: string
  }[]
  managers: {
    id: number
    name: string
  }[]
}

interface Props {
  labelGroupCategory: LabelGroupCategory
  isLoading: boolean
  deleteLabelGroupCallback: (labelGroupId: number) => void
  disableLabelGroupCallback: (labelGroupId: number, disable: boolean) => void
  copyLabelGroupCallback: (labelGroupId: number) => void
  pageOffsetCallback: (pageOffset: number) => void
  teams: Team[]
  creatable?: boolean
}

const LabelGroupForCategoryModule: FC<Props> = (props) => {
  const {
    labelGroupCategory,
    isLoading,
    deleteLabelGroupCallback,
    disableLabelGroupCallback,
    copyLabelGroupCallback,
    pageOffsetCallback,
    teams,
    creatable,
  } = props

  const DISPLAY_NUM = 5

  const [pageOffset, setPageOffset] = useState<number>(1)

  useEffect(() => {
    pageOffsetCallback(pageOffset)
  }, [pageOffset])

  return (
    <>
      <div className="project_category_row_detail">
        <div className="project_row_header">
          {
            labelGroupCategory.id ? (
              <>
                <FontAwesomeIcon
                  icon={['fas', 'folder']}
                  className="icon"
                  style={{
                    color: labelGroupCategory.color,
                  }}
                />
                {labelGroupCategory.category_name}
                に属するプロジェクト
              </>
            ) : (
              <>
                カテゴリーに属さないプロジェクト
              </>
            )
          }
        </div>
        {
          !isLoading && !labelGroupCategory.label_groups.length && (
            <>
              <div className="project_none">
                {
                  labelGroupCategory.id ? (
                    <>
                      {labelGroupCategory.category_name}
                      に属するプロジェクトはありません
                    </>
                  ) : (
                    <>
                      カテゴリーに属さないプロジェクトはありません
                    </>
                  )
                }
              </div>
            </>
          )
        }
        {
          labelGroupCategory.label_groups.map((label_group) => (
            <LabelGroupModule
              key={`label_group_${label_group.id}`}
              list={label_group}
              deleteLabelGroupCallback={(labelGroupId) => deleteLabelGroupCallback(labelGroupId)}
              disableLabelGroupCallback={(labelGroupId, disable) => disableLabelGroupCallback(labelGroupId, disable)}
              copyLabelGroupCallback={(labelGroupId) => copyLabelGroupCallback(labelGroupId)}
              teams={teams}
              creatable={creatable}
            />
          ))
        }
        {
          isLoading ? (
            <>
              <LoadingSquare>
                <>
                  プロジェクトを読み込んでいます…
                </>
              </LoadingSquare>
            </>
          ) : (
            <>
              {
                (DISPLAY_NUM * pageOffset) === labelGroupCategory.label_groups.length && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "16px",
                    }}
                  >
                    <button
                      type="button"
                      onClick={() => setPageOffset(pageOffset + 1)}
                      style={{
                        border: "solid 1px #CCCCCC",
                        borderRadius: "4px",
                      }}
                    >
                      さらに表示する
                    </button>
                  </div>
                )
              }
            </>
          )
        }
      </div>
    </>
  )
}

LabelGroupForCategoryModule.defaultProps = {
  creatable: true,
}

export default LabelGroupForCategoryModule
